import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ScheduleCreatePage, scheduleNewSearchSchema } from '@/features/schedules';

/** `?productIds=` (array, or a comma list) starts the pool: the products index hands over here. */
export const Route = createFileRoute('/_authed/_active/org/schedules/new')({
  staticData: { crumb: 'schedules:create.crumb', tours: ['schedules.new'] },
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    scheduleNewSearchSchema.parse(search),
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.write');
  },
  component: ScheduleCreatePage,
});
